
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



//////////////////
// WEBPACK FOOTER
// ./~/socket.io-client/~/engine.io-client/lib/index.js
// module id = 1118
// module chunks = 0